/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  path {
    &.line {
      fill: #294b72;
    }
    &.dark {
      fill: #152535;
    }
    &.blue {
      fill: #172f4b;
    }
    &.txt {
      fill: #eee;
    }
  }
`

export default class PickSolidIco extends PureComponent {
  render() {
    return (
      <svg id="그룹_5573" data-name="그룹 5573" xmlns="http://www.w3.org/2000/svg" width="16.683" height="9.504" viewBox="0 0 16.683 9.504" css={Color}>
        <rect id="사각형_1499" className="line" data-name="사각형 1499" width="16.683" height="9.504" rx="1" transform="translate(0 0)" fill="#294b72"/>
        <path id="패스_3743" className="dark" data-name="패스 3743" d="M.688.123,15.344,0a.61.61,0,0,1,.614.62L15.9,8.19a.635.635,0,0,1-.625.631L.614,8.944A.61.61,0,0,1,0,8.324L.063.754A.635.635,0,0,1,.688.123Z" transform="translate(0.322 0.266)" fill="#152535"/>
        <path id="패스_3744" className="blue" data-name="패스 3744" d="M8.577,3.965,15.344,0a.61.61,0,0,1,.614.62L15.9,8.19a.635.635,0,0,1-.625.631L.614,8.944A.61.61,0,0,1,0,8.324L7.952,4.6A.635.635,0,0,1,8.577,3.965Z" transform="translate(0.322 0.266)" fill="#172f4b"/>
        <path id="패스_4390" className="txt" data-name="패스 4390"
              d="M343.11,107.905v1.27h-.861v-3.707h1.415a1.542,1.542,0,0,1,1.046.336,1.2,1.2,0,0,1,0,1.766,1.543,1.543,0,0,1-1.046.334Zm0-.662h.555a.564.564,0,0,0,.428-.154.549.549,0,0,0,.148-.4.572.572,0,0,0-.146-.4.557.557,0,0,0-.429-.158h-.555Zm3.115,1.932h-.859v-3.707h.859Zm3.229-1.25,0,.015a1.191,1.191,0,0,1-.358.961,1.517,1.517,0,0,1-1.043.327,1.436,1.436,0,0,1-1.519-1.52v-.774a1.528,1.528,0,0,1,.4-1.1,1.4,1.4,0,0,1,1.06-.421,1.634,1.634,0,0,1,1.091.328,1.158,1.158,0,0,1,.376.955l-.008.015h-.837a.682.682,0,0,0-.145-.489.648.648,0,0,0-.476-.148.5.5,0,0,0-.446.233,1.1,1.1,0,0,0-.155.62v.779a1.037,1.037,0,0,0,.171.624.568.568,0,0,0,.489.234.544.544,0,0,0,.426-.148.741.741,0,0,0,.131-.494Zm1.32-.237h-.239v1.487h-.861v-3.707h.861v1.451h.178l.838-1.451h1.083l-1.166,1.684,1.265,2.022h-1.1Z"
              transform="translate(-339.149 -102.584)" fill="#eee"/>
      </svg>
    )
  }
}
